exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n.main-menu-button {\n  position: absolute;\n  left: 0; }\n\n.title {\n  text-align: center; }\n\n.printing-buttons {\n  width: 50vw;\n  margin: 0 auto;\n  text-align: left; }\n\n.printing-button {\n  margin: 2vh;\n  border: 1px #000055 solid;\n  color: #000055; }\n\n.printing-button:hover {\n  color: #3333cc; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/printing-page/printing-page.scss
// module id = ../../../../../src/app/admin-area/containers/printing-page/printing-page.scss
// module chunks = main